module.exports = __webpack_public_path__ + "static/media/excercise-attempted.4ddf1a9d.svg";